import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AuthenticationService } from '../../services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { ConfigSystemParams, dropdownSelectAllValues } from '../../consts';
import { ConfigSystemService } from '../../services/utelize/system/config-system/config-system-service';
import { DevicesService } from '../../services/utelize/system/device/devices-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { IdAndDescriptionDTO } from '../../interfaces/general/id-description';

@Component({
  selector: 'app-dropdown-device',
  templateUrl: './dropdown-device.component.html',
  styleUrls: ['./dropdown-device.component.scss']
})

export class DropdownDeviceComponent implements AfterViewInit, OnChanges, OnInit {

  @Input() companyId                  : number  | undefined;
  @Input() disabled                   : boolean | undefined;
  @Input() initialDeviceId            : number  | undefined;
  @Input() labelTop                   : boolean = true;  //CRN_20260529 - false=left of field
  @Input() retainFirstBlankOption     : boolean | undefined;
  @Input() showAllSureSimDevices      : boolean | undefined;
  @Input() showCompanySureSimDevices  : boolean | undefined;
  @Input() showHierarchySureSimDevices: boolean | undefined;
  @Input() userId                     : number  | undefined;
  
  @Output() selectOnChangeEvent     : EventEmitter<number> = new EventEmitter<number>();
  @Output() selectOnChangeIccidEvent: EventEmitter<string> = new EventEmitter<string>();

  get selectAllOption() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DropdownsProvideSelectAllOption, false ); }
  
  private curUserID    : number;
  private deviceIdData!: IdAndDescriptionDTO[];

  public addOrEditForm!   : UntypedFormGroup;
  public firstDeviceOption: string="";
  
  constructor(
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private devicesService       : DevicesService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : FormBuilder
  ) {
    this.curUserID=this.authenticationService.currentUserObject().userId;
  }

  ngOnInit(): void {
    try {
      this.getDropdownData();

      let deviceId          =this.initialDeviceId==undefined ? 0 : this.initialDeviceId;
      this.firstDeviceOption=!this.retainFirstBlankOption && this.selectAllOption ? dropdownSelectAllValues.Device : "";

      this.addOrEditForm=this.formBuilder.group({
        deviceID: [deviceId, []]
      });

      this.applyDisabledState();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes['disabled']) {
        this.applyDisabledState();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  ngAfterViewInit(){
    try {
      this.selectOnChange(undefined, undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public clearSelection() {
    try {
       this.addOrEditForm.get('deviceID')?.reset();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  public getDropdownDataObjectArray() {
    try {
      return this.deviceIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
 
  private applyDisabledState(): void {
    try {
      const control=this.addOrEditForm?.get('deviceID');

      if (control==undefined)
        return;

      if (this.disabled && control.enabled)
        control.disable({ emitEvent: false });
      
      else if (!this.disabled && control.disabled)
        control.enable({ emitEvent: false });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getDropdownData() {
    try {
      let dataSource: Observable<IdAndDescriptionDTO[]>;

      if (this.showAllSureSimDevices) {
        dataSource=this.devicesService.getIdAndDescription(this.curUserID);

      } else if (this.userId != undefined) {
        dataSource=this.devicesService.getIdAndDescriptionForUser(this.userId);
      } else if (this.showCompanySureSimDevices) {
        dataSource=this.devicesService.getIdAndDescriptionForCompany(this.companyId);
      } else if (this.showHierarchySureSimDevices) {
        dataSource=this.devicesService.getIdAndDescriptionForHierarchy(this.companyId);

      }
      else {
        dataSource=this.devicesService.getIdAndDescriptionForLoggedInUser(this.curUserID)
      }

      dataSource
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.deviceIdData=(data as IdAndDescriptionDTO[]);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshData() {
    this.getDropdownData();
  }

  public selectOnChange(event: Event | undefined, iccid: string | undefined) {
    try {
      let deviceID=this.addOrEditForm.controls["deviceID"].value;

      if (isNaN(deviceID) || deviceID=="") {
        deviceID=-1;
      }
      
      this.selectOnChangeEvent.emit(deviceID);
      this.selectOnChangeIccidEvent.emit(iccid);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
}
